import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cms_block = _resolveComponent("g-cms-block");
    return (_openBlock(), _createElementBlock("div", _normalizeProps(_guardReactiveProps(_ctx.content.config)), [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.slots, (slot) => {
            return (_openBlock(), _createBlock(_component_g_cms_block, { content: slot }, null, 8, ["content"]));
        }), 256))
    ], 16));
}
